// Section 10.1 - Jelentkezők száma alapján / Based on number of applicants
export const JELENTKEZOK_SZAMA_OPTIONS = {
    hu: [
        { value: 'piacvezeto', label: 'Piacvezető (legtöbb jelentkező)' },
        { value: 'top_3', label: 'Top 3 pozíció' },
        { value: 'kozepmezony', label: 'Középmezőny' },
        { value: 'also_harmad', label: 'Alsó harmad' },
        { value: 'legkevesebb', label: 'Legkevesebb jelentkező' }
    ],
    en: [
        { value: 'piacvezeto', label: 'Market leader (highest number of applicants)' },
        { value: 'top_3', label: 'Top 3 position' },
        { value: 'kozepmezony', label: 'Middle tier' },
        { value: 'also_harmad', label: 'Lower tier' },
        { value: 'legkevesebb', label: 'Lowest number of applicants' }
    ]
};

// Section 10.1 - Versenyképesség értékelése / Competitiveness assessment
export const VERSENYKEPESSEG_OPTIONS = {
    hu: [
        { value: 'eros', label: 'Erős versenyképesség (növekvő részesedés)' },
        { value: 'stabil', label: 'Stabil versenyképesség' },
        { value: 'gyengulo_csokkeno', label: 'Gyengülő versenyképesség (csökkenő részesedés)' },
        { value: 'jelentosen_gyengulo', label: 'Jelentősen gyengülő pozíció' }
    ],
    en: [
        { value: 'eros', label: 'Strong competitiveness (increasing market share)' },
        { value: 'stabil', label: 'Stable competitiveness' },
        { value: 'gyengulo_csokkeno', label: 'Declining competitiveness (decreasing market share)' },
        { value: 'jelentosen_gyengulo', label: 'Significantly weakening position' }
    ]
};

// Section 10.2 - Nemzetközi együttműködés lehetőségei / International collaboration opportunities
export const NEMZETKOZI_LEHETOSEGEK_OPTIONS = {
    hu: [
        { value: 'hallgatoi_mobilitas', label: 'Hallgatói mobilitás' },
        { value: 'oktatoi_mobilitas', label: 'Oktatói mobilitás' },
        { value: 'nyari_egyetemek', label: 'Nyári egyetemek' },
        { value: 'kutatasi_egyuttmukodes', label: 'Kutatási együttműködések' },
        { value: 'tantargyfejlesztes', label: 'Tantárgyfejlesztés együttműködések' },
        { value: 'intezmenyi_egyuttmukodes', label: 'Intézményi együttműködések' },
        { value: 'vendegprofesszor', label: 'Vendégprofesszor meghívása' }
    ],
    en: [
        { value: 'hallgatoi_mobilitas', label: 'Student mobility' },
        { value: 'oktatoi_mobilitas', label: 'Staff mobility' },
        { value: 'nyari_egyetemek', label: 'Summer schools' },
        { value: 'kutatasi_egyuttmukodes', label: 'Research collaboration' },
        { value: 'tantargyfejlesztes', label: 'Course development collaboration' },
        { value: 'intezmenyi_egyuttmukodes', label: 'Institutional partnerships' },
        { value: 'vendegprofesszor', label: 'Invitation of visiting professors' }
    ]
};

// Section 10.2 - Jelenlegi partnerek típusa / Current partners type
export const JELENLEGI_PARTNEREK_OPTIONS = {
    hu: [
        { value: 'csereprogram', label: 'Csereprogram' },
        { value: 'double_degree', label: 'Double degree program' },
        { value: 'joint_degree', label: 'Joint degree program' },
        { value: 'kutatasi_egyuttmukodes', label: 'Kutatási együttműködés' },
        { value: 'oktatoi_mobilitas', label: 'Oktatói mobilitás' },
        { value: 'nyari_egyetem', label: 'Nyári egyetem' },
        { value: 'vendegprofesszor', label: 'Vendégprofesszor' },
        { value: 'egyeb', label: 'Egyéb:' }
    ],
    en: [
        { value: 'csereprogram', label: 'Exchange programme' },
        { value: 'double_degree', label: 'Double degree programme' },
        { value: 'joint_degree', label: 'Joint degree programme' },
        { value: 'kutatasi_egyuttmukodes', label: 'Research collaboration' },
        { value: 'oktatoi_mobilitas', label: 'Staff mobility' },
        { value: 'nyari_egyetem', label: 'Summer school' },
        { value: 'vendegprofesszor', label: 'Visiting professor' },
        { value: 'egyeb', label: 'Other:' }
    ]
};

// Section 10.3 - A szak angol nyelvű képzési státusza / English-language programme status
export const ANGOL_NYELVU_STATUSZ_OPTIONS = {
    hu: [
        { value: 'teljes_angol', label: 'Teljesen angol nyelvű program' },
        { value: 'reszleges_angol', label: 'Részleges angol nyelvű program (egyes tantárgyak)' },
        { value: 'nincs_tervezzuk', label: 'Nincs, de tervezzük elindítani' },
        { value: 'nincs_sem_tervezzuk', label: 'Nincs angol nyelvű program, nem is tervezzük' }
    ],
    en: [
        { value: 'teljes_angol', label: 'Fully English-taught programme' },
        { value: 'reszleges_angol', label: 'Partially English-taught programme (selected courses offered in English)' },
        { value: 'nincs_tervezzuk', label: 'No English-taught programme currently offered, but planned' },
        { value: 'nincs_sem_tervezzuk', label: 'No English-taught programme offered and not planned' }
    ]
};
